import Styled from 'styled-components'

export default Styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  margin: -1.5rem;

  ${props => props.compact && `
    margin: -0.75rem;
  `}
`



// WEBPACK FOOTER //
// ./src/components/Columns/index.js